<template>
  <BreadCrumb PageTitle="Nouveaux livreurs" />
  <NewDrivers />
</template>

<script lang="ts">
import { defineComponent } from "vue";

import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import NewDrivers from "../../components/Users/UsersList/NewDrivers.vue";


export default defineComponent({
  name: "NewDriversPage",
  components: {
    BreadCrumb,
    NewDrivers,
  },
});
</script>